import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useForm, ErrorMessage } from "react-hook-form";
import { Helmet } from 'react-helmet';
import withSizes from 'react-sizes';

import { Container, Row, Col } from "deltoid/core/Blocks/BootstrapContainers";
import { Card } from "deltoid/core/OneDashCards";
import { H, Caption } from "deltoid/core/Blocks/Typography";
import Form from "deltoid/core/Form";

import SignUpCMS from "../../features/prismic/SignUpCMS";
import SignInPartnerCMS from "../../features/prismic/SignInPartnerCMS";
import config from "../../../shared/services/config";
import { fetchUser, loginWithPassword, clearUser } from '../../../shared/actions/auth';
import { UserResponse } from '../../../shared/utils/response';
import { emailRegex } from '../../../shared/services/validations';
import { fetchQueryParamsFromSession } from "../../../shared/services/utils";
import LoginIllustration from "../../../assets/svgs/loginIllustration.svg";
import PayUIcon from "../../../assets/svgs/PayU-Icon.svg";
import AuthManager from '../../../shared/services/AuthManager';


const SignIn = (props) => {
  const { register, handleSubmit, errors, getValues, setValue, setError, clearError } = useForm({ mode: 'onChange' });
  const { user } = props;
  const userRef = useRef(user);
  userRef.current = user;
  const [passwordShown, setPasswordShown] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [userFetched, setUserFetched] = useState(null);
  const [isLoginWithOtp, setLoginWithOtp] = useState(false);
  const isPartner = config.get('product') === 'PARTNER';
  const [isMobileNotRequired, setIsMobileNotRequired] = useState(false);

  useEffect(() => {
    const sessionParams = fetchQueryParamsFromSession();
    if (sessionParams && sessionParams.email) {
      const email = sessionParams.email;
      if (!emailRegex(email)) {
        setValue('email', email);
        fetchUserData();
      }
    }
  }, [])

  useEffect(() => {
    const userData = UserResponse(user || {});
    const isMFAEnabled = userData.isMFAEnabled && userData.isPasswordSet

    if (user) {
      if (config.get("productCheck", null)) {
        config.get("productCheck")(user, userData.email)
          .then((userProducts) => {
            const merchant_product = userProducts ? userProducts.merchant_product : '';
            const products = userProducts ? userProducts.products : [];
            /**
             * if PayUBiz merchants tries to login on PayUNow/payumoney
             * then redirect them to payu.in
             */
            setIsMobileNotRequired(userProducts?.mobile_disabled)
            if (config.get('product') === 'PAYUNOW' && products.includes('PayUbiz')) {
              const index = window.location.host.indexOf('now.com');
              const redirectionUrl = `${window.location.protocol}//${window.location.host.slice(0, index)}.in`;
              window.location.href = `${redirectionUrl}/app/account?email=${userData.email}`;
            } else if (config.get('product') === 'PAYUMONEY' && merchant_product == 'PayUbiz') {
              const index = window.location.host.indexOf('money.com');
              const redirectionUrl = `${window.location.protocol}//${window.location.host.slice(0, index)}.in`;
              window.location.href = `${redirectionUrl}/app/account?email=${userData.email}`;
            }
            if (userFetched && user && user.length == 0) {
              setError('email', 'validation', 'The user id does not exist. Please try to Sign up instead.')
              setIsDisabled(true);
            }
            else if (user && user.length > 0) {
              setIsDisabled(false);
              if(!userProducts?.mobile_disabled && !userData?.mobile){
                props.history.push({
                  pathname: '/account/set-mobile',
                  state: {
                    ...props.location.state,
                    useMobile: true,
                    user: UserResponse(user),
                    userEmail: UserResponse(user).email,
                    isMobileNotRequired: userProducts?.mobile_disabled,
                    signup: true,
                    setPassword: true,
                    isLogin: true,
                  }
                });
              } else if (!userData.isPasswordSet) {
                props.history.push({
                  pathname: '/account/mobile_otp',
                  state: {
                    ...props.location.state,
                    useMobile: true,
                    user: UserResponse(user),
                    userEmail: UserResponse(user).email,
                    isMobileNotRequired: userProducts?.mobile_disabled,
                    signup: true,
                    setPassword: true,
                    isLogin: true,
                  }
                });
              }
            }
            const email = getValues('email');
            if (!isMFAEnabled && !userProducts?.mobile_disabled && isLoginWithOtp && email && user && user.length > 0) {
              props.history.push({
                pathname: '/account/mobile_otp',
                state: {
                  ...props.location.state,
                  user: userData,
                  isLogin: true,
                }
              });
            }
          })
      }
    }
  }, [user, isLoginWithOtp])

  useEffect(() => {
    const email = getValues('email');
    if (isLoginWithOtp && emailRegex(email)) {
      setError('email', 'validation', 'Enter your registered email id')
      // setLoginWithOtp(false);
    }
    else {
      clearError('email');
    }
  }, [isLoginWithOtp])

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  }

  const forgotPasswordClick = () => {
    props.history.push({
      pathname: '/account/forgot_password',
    });
  }

  const onSubmit = async (formData) => {
    if (!userRef.current) {
      setError('email', 'regex', 'Wait for few seconds and resubmit')
      setTimeout(() => {
        onSubmit(formData)
      }, 1000)
      return
    }
    if (!formData.password) {
      setError('password', 'regex', 'Password can not be empty')
    }
    try {
      const userData = UserResponse(userRef.current);
      const isMFAEnabled = userData.isMFAEnabled && userData.isPasswordSet
      if (!userData.mobileVerified) {
        props.history.push({
          pathname: '/account/mobile_otp',
          state: {
            ...props.location.state,
            useMobile: true,
            user: UserResponse(userRef.current),
            userEmail: UserResponse(userRef.current).email,
            password: formData.password,
          }
        });
      }
      const loginWithPasswordResponse = await loginWithPassword(props.dispatch, { ...formData, isMFAEnabled });
      if (isMFAEnabled) {
        props.history.push({
          pathname: '/account/mobile_otp',
          state: {
            ...props.location.state,
            useMobile: true,
            user: UserResponse(userRef.current),
            userEmail: UserResponse(userRef.current).email,
            password: formData.password,
            isMFAEnabled,
            isLogin: true,
            passwordToken: loginWithPasswordResponse.access_token
          }
        });
      } else {
        props.history.push({
          pathname: '/account/setting-up',
          state: {
            ...props.location.state,
            user: userData,
          }
        });
      }

    } catch (e) {
      setError('password', 'regex', e.message)
    }
  };

  const fetchUserData = async () => {
    try {
      const email = getValues('email');
      if (!emailRegex(email)) {
        await fetchUser(props.dispatch, { email })
        setUserFetched(true);
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  const clearUserData = async () => {
    try {
      await clearUser(props.dispatch);
      props.history.push({
        pathname: "/account/signup",
      })
    }
    catch (e) {
    }
  }

  const isStaffInviteLink = AuthManager.getQueryParams().includes('invitation_code')
  const isMFAEnabled = props.user && UserResponse(props.user).isMFAEnabled && UserResponse(props.user).isPasswordSet
  return (
    <Container fluid className='vector-bg login-max-width-container'>
      <Helmet>
        <meta name="description" content="Online payment gateway in India for Start-ups, Enterprises & Freelancers with 150+ payment modes." />
        <title>Login to PayU</title>
      </Helmet>
      <Row>
        <Col md={6} className='p-0'>
          {isPartner ? <SignInPartnerCMS /> : <SignUpCMS />}
        </Col>
        <Col md={5} className={props.isMobile && 'm-0 p-0'}>
          <div className={!props.isMobile && 'login-container mt-5 mx-4'}>
            <Card>
              <H level={5} variant="regular" className="pb-4 co-heading worksansregular-font">
                Login to your PayU {isPartner && 'partner '}account
              </H>
              <form onSubmit={handleSubmit(onSubmit)} className='px-3 py-3'>
                <Row>
                  <Form.Group className="position-relative mb-3">
                    <Form.Label id="email">
                      Email
                    </Form.Label>
                    <Form.Text
                      id="email"
                      name="email"
                      type="email"
                      placeholder="Enter your email id"
                      ref={register({
                        required: "Email can not be empty",
                        validate: { regex: emailRegex },
                      })}
                      onChange={fetchUserData}
                      disabled={!!isStaffInviteLink}
                    />
                    <ErrorMessage errors={errors} name="email">
                      {({ message }) => (
                        <Form.Message
                          type="error"
                        >
                          {message}
                        </Form.Message>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="position-relative mb-3">
                    <Form.Label id="password">
                      Password
                    </Form.Label>
                    <Form.Text
                      id="password"
                      name="password"
                      autoComplete="new-password"
                      type={passwordShown ? "text" : "password"}
                      ref={register({
                        required: "Password can not be empty",
                      })}
                      placeholder="Enter your PayU Password"
                      endAdornment={{
                        type: `${passwordShown ? 'view-disabled' : 'view-1'}`,
                        color: 'default',
                        size: '18px',
                        onClick: () => togglePasswordVisiblity()
                      }}
                    />
                    <ErrorMessage errors={errors} name="password">
                      {({ message }) => (
                        <Form.Message
                          type="error"
                        >
                          {message}
                        </Form.Message>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Row>
                <div className="d-flex flex-column-reverse row">
                  <div className="justify-content-end pt-3">
                    <Form.Button
                      type="submit"
                      className="w-100 mt-4 font-weight-bold rounded-btn"
                      disabled={isDisabled}
                    >
                      Login
                    </Form.Button>
                  </div>
                  <div className="d-flex justify-content-between why-btn">
                    <Form.Button
                      type="button"
                      onClick={() => setLoginWithOtp(true)}
                      variant="underlined"
                      className="p-0 position-relative"
                      endIcon={isMFAEnabled || isMobileNotRequired ? { type: 'lock', color: 'dark'} : {}}
                      onMouseEnter={() => setShowTooltip(isMFAEnabled || isMobileNotRequired)}
                      onMouseLeave={() => setShowTooltip(false)}
                    >
                      Login using OTP
                      {
                        isMFAEnabled || isMobileNotRequired ? (
                          <div className={`tooltip-container ${showTooltip ? '' : 'hide'}`}>
                            {isMFAEnabled ? 'Two Step Verification is enabled' : 'Mobile OTP is disabled'}
                          </div>
                        ) : null
                      }
                    </Form.Button>
                    <Form.Button onClick={forgotPasswordClick} variant="underlined" className="p-0" type="button" >
                      Forgot Password
                    </Form.Button>
                  </div>
                </div>
                <Row className="d-flex justify-content-center pt-2">
                  <Caption variant="light" className={props.isMobile ? 'pt-1 align-button-text pr-2' : 'align-button-text pr-3'}>
                    Don’t have an account with PayU?
                  </Caption>
                  <Form.Button
                    onClick={clearUserData}
                    variant="underlined"
                  >
                    Sign Up
                  </Form.Button>
                </Row>
              </form>
            </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

const mapStateToProps = (state) => {
  return {
    user: state.session.User.data.data,
  };
};

const Responsive = withSizes(mapSizesToProps)(SignIn);
export default connect(mapStateToProps, mapDispatchToProps)(Responsive);